export const techAndMeasures = {
  categories: {
    wastewater: '废水',
    energy: '能源',
    water: '水',
    energyAndWater: '能源 和 水'
  },
  allProjects: {
    title: '所有项目'
  },
  topProjects: {
    title: '最佳项目'
  },
  quickWins: {
    title: '速效方案'
  },
  measure: '措施',
  type: '类型',
  category: '种类',
  estimatedInvestment: '预计投资支出',
  estimatedOperational: '估计运营支出',
  traditionalTechnologyDesc: '传统技术描述',
  mainBenefitsOfBestAvailableTechnology: '最佳可用技术的主要优势',
  resourceReductionProposedTechnology:
    '提议技术与传统技术在减少消耗资源的对比',
  bestAvailableTechnologyInfo: '最佳可用技术制造商信息',
  description: '描述',
  bestAvailableTechnologyDescription: '最佳可用技术描述',
  caseStudy: '案例研究',
  resourceReduction: '资源减少',
  limitations: '局限性',
  implementationDifficulty: '实施难度',
  potentialChemicalSuppliers: '潜在化学品供应商',
  avoidanceOfStandardizedWashOffAfterContinuousPrinting:
    '避免连续印刷后的标准化冲洗',
  optimizationOfExhaustDyeingMachineCapacity: '浸染机容量的优化',
  adequateProductionPlanning: '充分合适的生产计划',
  avoidanceOfBleachingInDarkShades: '避免深色漂白',
  centrifugationAfterGarmentDyeingWithReactiveDyes:
    '成衣活性染料染色后离心',
  installationOfHandTriggersAtWaterHoses: '在水管上安装手动触发器',
  energyReduction: '耗能减少',
  caseStudyResReducCalc: '资源减少的案例研究',
  targetParameter: '目标参数',
  otherMeasures: '其他措施',
  impactEnergy: '能源影响:',
  impactWater: '水影响:',
  recommendations: '建议',
  filter: '过滤器',
  etpType: 'ETP类型',
  parameter: '参数',
  expenditureInvestement: '投资',
  impact: '影响',
  orderby: '订购方式',
  noData: '没有与筛选后匹配的数据',
  clearAll: '清除',
  clear: '清除'
};
